import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { async } from 'rxjs/internal/scheduler/async';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { SeoService } from '../service/seo.service';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  serviceForm: FormGroup;

  contactDetails: any;
  branchDetails: any;
  loadAPI: Promise<any>;
  constructor(private formBuilder: FormBuilder, private afs: AngularFirestore, private _seo: SeoService, private router: Router) {
 
  }

  ngOnInit() {
    this.serviceForm = this.formBuilder.group({
      cname: ['', Validators.required],
      cemail: ['', Validators.required],
      cmob: ['', Validators.required],
      cmgs: ['', Validators.required],
    })
  }

  onSubmit(valid, value) {
    console.log(value)
    if (valid) {
        value.status = false;
        value.createdAt = new Date().toString()
        this.afs.collection('messages').add(value);
        this.router.navigate(['/']);
        alert('Message Send successfully!');
    } else return false
  }

}
